export default function dosesAtDays(props) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="35" height="35" rx="11.5" fill="white" stroke="#EAEBEC" />
            <circle cx="9" cy="27" r="3" transform="rotate(-90 9 27)" fill="url(#paint0_radial_2497_51786)" />
            <circle cx="9" cy="9" r="3" transform="rotate(-90 9 9)" fill="url(#paint1_radial_2497_51786)" />
            <circle cx="9" cy="18" r="3" transform="rotate(-90 9 18)" fill="url(#paint2_radial_2497_51786)" />
            <circle cx="17" cy="27" r="3" transform="rotate(-90 17 27)" fill="url(#paint3_radial_2497_51786)" />
            <circle cx="17" cy="9" r="3" transform="rotate(-90 17 9)" fill="url(#paint4_radial_2497_51786)" />
            <circle cx="17" cy="18" r="3" transform="rotate(-90 17 18)" fill="url(#paint5_radial_2497_51786)" />
            <g clipPath="url(#clip0_2497_51786)">
                <path d="M27.4286 15V17.5714H30V18.4286H27.4286V21H26.5714V18.4286H24V17.5714H26.5714V15H27.4286Z" fill="url(#paint6_radial_2497_51786)" stroke="url(#paint7_radial_2497_51786)" />
            </g>
            <defs>
                <radialGradient id="paint0_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.68377 24) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint1_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.68377 6) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint2_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.68377 15) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint3_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.6838 24) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint4_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.6838 6) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint5_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.6838 15) rotate(81.7922) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint6_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(24 18.3162) rotate(-8.20779) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <radialGradient id="paint7_radial_2497_51786" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(24 18.3162) rotate(-8.20779) scale(11.347 13.4566)">
                    <stop stopColor="#253FC4" />
                    <stop offset="1" stopColor="#000D4F" />
                </radialGradient>
                <clipPath id="clip0_2497_51786">
                    <rect width="6" height="6" fill="white" transform="matrix(0 -1 1 0 24 21)" />
                </clipPath>
            </defs>
        </svg>
    )
}